<template>
  <div class="container-fluid h-100">
    <div class="container">
      <!-- Historial de categorías -->
      <div style="margin-top:100px;" class="card">
        <div class="card-body">
          <template>
            <div class="table-responsive">
              <table class="table table-striped table-sm">
                <caption class="visually-hidden">List History</caption>
                <thead>
                  <tr>
                    <th id="ab-1">Links generados</th>
                    <th id="ab-2">Destino del link</th>
                    <th id="ab-3">Estado</th>
                    <th id="ab-4">Acción</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="link in linksAll" v-bind:key="link.id">
                    <td>
                      {{ link.full_link }}
                    </td>
                    <td>
                      {{ link.link_destination == 1 ? '/landing/register' : link.link_destination == 2 ? '/quick/registration' : '' }}
                    </td>
                    <td>
                      <label
                        v-if="link.status_id == 1"
                        style="color: #dc3545"
                      >
                        Activo
                      </label>
                      <label v-else style="color: gray">
                        Inactivo
                      </label>
                    </td>
                    <td>
                      <div class="btn-group" role="group">
                        <div class="btn-group" role="group">
                          <button
                            class="btn btn-secondary"
                            title="Editar"
                            data-toggle="modal"
                            data-target="#modalUpdateLink"
                            @click="editLinks(link)"
                          >
                            Editar
                          </button>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </template>
        </div>
      </div>

      <!-- Modal Editar Link -->
      <div
        class="modal fade "
        id="modalUpdateLink"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
          <div style="border:none;" class="modal-content modal-question">
            <div class="modal-body">
              <button
                type="button"
                data-dismiss="modal"
                aria-label="Close"
                class="close"
              >
                <i class="fa fa-times-circle text-danger" aria-hidden="true"></i>
              </button>
              <div class="mt-3 row justify-content-center">
                <div class="col-12 mb-3">
                  <label style="color: #616161;">
                    <strong style="font-size:20px">Editar link</strong> 
                  </label><br><br>
                </div>
                <div style="min-width:100%;" class="form-group">
                  <div class="row mb-3">
                    <div class="col-6" style="text-align:start; margin:auto;">
                      <label for="state" style="color: #616161;"
                        ><strong>Estado del link:</strong>
                      </label>
                      <select
                        class="form-control"
                        name="state"
                        id="state"
                        v-model="linkUpdate.status_id"
                      >
                        <option value="0" disabled selected>Seleccione</option>
                        <option value="1">Activar</option>
                        <option value="2">Inactivar</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="col-10 col-md-5 col-lg-4 col-xl-4 col-sm-10 mt-3">
                  <button
                    data-dismiss="modal"
                    type="button"
                    class="btn btn-secondary btn-sm btn-block button-login"
                  >
                    Cancelar
                  </button>
                </div>
                <div
                  class="col-10 col-md-5 col-lg-4 col-xl-4 col-sm-10 mt-3 mb-3"
                >
                  <button
                    @click="updateLinks()"
                    type="button"
                    class="btn btn-danger btn-sm btn-block button-login"
                  >
                    <template v-if="loading.changeDoc">
                      <span
                        class="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      Actualizando...
                    </template>
                    <template v-else>Actualizar</template>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <button
        style="margin:10px auto 0px 0px"
        @click="back()"
        type="button"
        class="btn btn-danger btn-sm button-login"
      >
        Regresar
      </button>
    </div>
  </div>
</template>
  
<script>
  import $ from "jquery";
  import axios from 'axios'

  export default {
    data() {
      return {
        linksAll: [],
        form: {
          status: 1,
          description: "",
          type_link: null,
          cant_points: null,
          expiration_date: null,
          type_user: null,
          link: "",
          full_link: "",
          link_generated: null,
        },
        errors: {
          type_link: false,
          cant_points: false,
          expiration_date: false,
          type_user: false,
        },
        loading: {
          changeDoc: false,
        },
        linkUpdate: {
          status_id: 1,
        },
      };
    },
    methods: {
      editLinks(link){
        // console.log(JSON.stringify(link));
        let app = this;
        app.linkUpdate.id = link.id;
        app.linkUpdate.status_id = link.status_id;
        return link;
      },
      back(){
        this.$router.push({ name: "updateDataOrRegister" });
      },
      updateLinks(){
        let app = this;
        app.loading.changeDoc = true;
        axios
        .post("superAdmin/edit/links", app.linkUpdate)
        .then((res) => {
          if(res.data.cod == 0){
            app.$swal({
              confirmButtonColor: "#dc3545",
              icon: "success",
              title: "Muy bien",
              text: res.data.message
            });
            app.loading.changeDoc = false;
            $("#modalUpdateLink").modal("hide");
            app.getLinks();
          }
        })
        .catch((error) => {
          app.loading.changeDoc = false;
          app.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: error.response.data.message
          });
        });
      },
      clearForm(){
        this.form.description = "";
        this.form.type_link = null;
        this.form.cant_points = null;
        this.form.expiration_date = null;
        this.form.type_user = null;
        this.form.link = "";
        this.form.full_link = "";
        this.form.link_generated = null;
        setTimeout(() => {
          this.errors.type_link = false;
          this.errors.cant_points = false;
          this.errors.expiration_date = false;
          this.errors.type_user = false;
        },0);
      },
      validForm(){
        let app = this;
        if(app.form.type_link == null){
          app.errors.type_link = "El tipo de link es requerido.";
          return false;
        }
        if(app.form.cant_points == null){
          app.errors.cant_points = "La cantidad de puntos es requerida.";
          return false;
        }
        if(app.form.expiration_date == null){
          app.errors.expiration_date = "La fecha de vencimiento del link es requerida";
          return false;
        }
        if(app.form.type_user == null){
          app.errors.type_user = "El tipo de usuario es requerido.";
          return false;
        }
        return true;
      },
      createLink(){ 
        const formData = new FormData();
        formData.append("status", this.form.status);
        formData.append("description", this.form.description);
        formData.append("type_link", this.form.type_link);
        formData.append("cant_points", this.form.cant_points);
        formData.append("expiration_date", this.form.expiration_date);
        formData.append("type_user", this.form.type_user);
        formData.append("link", this.form.link);
        formData.append("full_link", this.form.full_link);
        if(this.validForm()){
          this.loading.changeDoc = true;
          axios
          .post("superAdmin/create/links", formData)
          .then((res) => {
            // console.log('res.data: ', JSON.stringify(res.data));
            if (res.data.cod == 0) {
              this.$swal({
                confirmButtonColor: "#dc3545",
                icon: "success",
                title: "Muy bien",
                text: res.data.message,
              });
              this.loading.changeDoc = false;
              this.clearForm();
              this.getLinks();
            }
          })
          .catch((error) => {
            this.loading.changeDoc = false;
            this.$swal({
              confirmButtonColor: "#dc3545",
              icon: "error",
              title: "Oops...",
              text: error.response.data.message,
            });
          });
        }
      },
      getLinks(){
        axios
        .get("api/get/links/all")
        .then((res) => {
          // console.log('res.data.data: ', JSON.stringify(res.data.data));
          if (res.data.cod == 0){
            this.linksAll = res.data.data;
          }
        })
        .catch((error) => {
          this.loading.changeDoc = false;
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: error.response.data.message,
          });
        });
      },
    },
    watch: {
      "form.type_link": function(newV) {
        if (!newV) {
          this.errors.type_link = "El tipo de link es requerido.";
        } else {
          this.errors.type_link = false;
        }
      },
      "form.cant_points": function(newV) {
        if (!newV) {
          this.errors.cant_points = "La cantidad de puntos es requerida.";
        } else {
          this.errors.cant_points = false;
        }
      },
      "form.expiration_date": function(newV) {
        if (!newV) {
          this.errors.expiration_date = "La fecha de vencimiento del link es requerida";
        } else {
          this.errors.expiration_date = false;
        }
      },
      "form.type_user": function(newV) {
        if (!newV) {
          this.errors.type_user = "El tipo de usuario es requerido.";
        } else {
          this.errors.type_user = false;
        }
      },
    },
    mounted(){
      this.getLinks();
    },
  };
</script>
    
<style>
.container-fluid,
.container-lg,
.container-md,
.container-sm,
.container-xl {
  padding-right: 0px !important;
  padding-left: 0px !important;
  overflow: hidden;
}
.hr-border {
  border-top: 1px solid rgb(198 198 198);
  height: 15px;
  width: 100%;
  background-color: white;
}
.div-button {
  margin-top: 50px;
  text-align: left;
}
.is-danger {
  border: solid 2px !important;
  border-color: #e9434c !important;
}
.modal-title {
  color: black;
  font-weight: bold;
}
.modal-question {
  border: solid 3px;
  border-color: #dc3545;
  border-radius: 15px;
}
label {
  color: black;
  margin-right: 4px;
}
.img-banner {
  display: block;
  width: 25%;
  text-align: center;
  margin: auto;
}
td {
  text-align: center;
  vertical-align: -webkit-baseline-middle;
  cursor: all-scroll;
}
.table-container {
  overflow: auto;
}
h5 {
  margin-bottom: 10px !important;
}
.commentary {
  text-align: left;
  color: #1da5df;
  font-size: 13px;
}
.page-item.active .page-link {
  border-style: none;
  border-radius: 20px;
  background-color: #dc3545;
}
a.page-link {
  color: black;
  cursor: pointer;
}
a.page-link:hover {
  color: #dc3545;
}
.page-link {
  background-color: #f5f5dc00;
  border-radius: 20px;
  border-color: none;
}
.page-item.disabled .page-link {
  color: #dc3545;
  background-color: #fff0;
  border-color: #dee2e600;
}
.ul-pagination {
  padding: 0px;
}
.multiselect__tag {
  background-color: #dc3545 !important;
}
.multiselect__tag-icon:after {
  color: #ffffff;
  font-size: 18px;
}
.multiselect__tag-icon:hover {
  color: #ffffff;
  font-size: 18px;
  background-color: #b80012;
}
.multiselect__option--highlight {
  background: #17a2b8;
  outline: none;
  color: #fff;
}
.alert-danger {
  border-color: red !important;
}
.btn_history{
  margin:0px 0px 0px 20px;
  background-color:#17a2b8;
}
.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}
</style>